<template>
  <challenge-layout
    :challenge-header-props="{
      challengeName: challenge.name,
      shortDescription: challenge.shortDescription ?? '',
      descriptionSize: DescriptionSize.LARGE
    }"
  >
    <template v-slot:cards>
      <challenge-summary-card @click="redirectToCashflow" />
    </template>
  </challenge-layout>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import ChallengeSummaryCard from './ChallengeSummaryCard.vue';
import ChallengeLayout from '../../layouts/ChallengeLayout.vue';
import { DescriptionSize } from '../ChallengeHeader/DescriptionSize';
import { useChallengeStore } from '../../stores/challenge';
import Segment from '../../Segment';
import config from '../../config';
import useTrackDashboardVisit from '../../composables/useTrackDashboardVisit';

const challengeStore = useChallengeStore();
const { challenge } = storeToRefs(challengeStore);
const CASHFLOW_URL = `${config.get().cashflowPublicUrl}/sr`;
const { trackDashboardVisitedEvent } = useTrackDashboardVisit();
trackDashboardVisitedEvent('challenge_ended_page');

const redirectToCashflow = () => {
  Segment.trackUserInteraction('_challenge_ended_back_to_cashflow_Clicked', {
    challengeId: challenge?.value?.challengeId,
  });
  window.location.href = CASHFLOW_URL;
};
</script>

<style lang="scss" scoped>
.header-section {
  display: grid;
  grid-template-columns: 2.5fr 0.5fr;
  height: 198px;
  gap: 16px;
}

</style>
